import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { addOrRemoveQueries } from 'Utils/routerUtils'

import LeadAutoComplete from 'Components/LeadAutoComplete'
import WithWindowSize from 'Components/WithWindowSize'

import {
  _AlertLeadSearch,
  _InputWrap,
} from './styles'

class LeadSavedSearchSelector extends Component {
  constructor(props) {
    super(props)
    this.handleUserSelect = this.handleUserSelect.bind(this)
    this.onInputBlur = this.onInputBlur.bind(this)
  }
  onInputBlur() {
    const winWidth = this.props.winWidth
    if(winWidth > 766) this.props.closeAutoComplete()
  }
  handleUserSelect(lead) {
    if(lead && lead.id) {
      addOrRemoveQueries({
        lead_id: [lead.id],
      })
      this.props.closeAutoComplete()
    }
  }

  render() {
    return (
      <_AlertLeadSearch>
        <_InputWrap>
          <LeadAutoComplete
            handleUserSelect={this.handleUserSelect}
            onBlur={this.onInputBlur}
            autoFocus
          />
        </_InputWrap>
      </_AlertLeadSearch>
    )
  }
}


LeadSavedSearchSelector.propTypes = {
  closeAutoComplete: PropTypes.func,
  winWidth: PropTypes.number,
}

export default WithWindowSize(LeadSavedSearchSelector)
